<template>
  <div class="exchange-container" :style="{
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
  }">
    <div class="score-box">
      <div class="left">
        <div class="text" :style="{'color': gc.font_color || gc.main_color}">我的积分：</div>
        <div class="num" :style="{'color': gc.font_color || gc.main_color}">{{score_left}}</div>
      </div>
      <div class="right" @click="getRecordList" :style="{'color': gc.font_color || gc.main_color}">兑换记录</div>
    </div>
    <div class="exchange-list" :class="{'center': redeem_list && redeem_list.length < 3}">
      <div
      class="item" 
      v-for="(item, index) in redeem_list" 
      :key="item.item_id" 
      :class="{'exchanged': item.reach_limit == 1 || item.left_state == 0}"
      :style="{'background': `url(${cc.bg}) no-repeat center/100% 100%`,'margin': index % 3 === 1 ? '0 2px 20px' : '0 0 20px'}"
      >
        <div class="outer-box">
          <div class="img-box">
            <img :src="item.img_url" alt="">
          </div>
          <div class="inner-box">
            <p class="desc" id="desc" :style="{'color': hexToRgba(gc.main_color, .8)}">
              <span class="limit" v-if="item.limit_count" :style="{'background-color': cc.text_color1 || gc.main_color, 'color': hexToRgba(gc.text_color, .9)}">限{{item.limit_count}}次</span>
              {{item.name}}
            </p>
            <div class="exchange-btn" @click="showConfirmModal(item)" :style="{
              'border-radius': cc.btn_radius + 'px',
              'background-color': (item.reach_limit == 1 || item.left_state == 0) ? '' : (cc.btn_color || gc.main_color)
            }">
              <!-- 不管有没有剩余，兑换达到了上限 -->
              <span v-if="item.reach_limit == 1" :style="{'color': cc.btn_text_color ? hexToRgba(cc.btn_text_color, .5) : hexToRgba(gc.main_color, .5)}">已兑换</span>
              <template v-else>
                <!-- 不限量 or 有剩余 同时 没达到兑换上限  -->
                <template v-if="(!item.left_state || item.left_state == 1) && item.left_state != 0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.70745 6.65905C8.85427 6.86797 8.92855 7.08592 8.92855 7.30827C8.92855 8.39871 7.16622 9.28578 4.99998 9.28578C2.83374 9.28578 1.07141 8.39871 1.07141 7.30827C1.07141 7.08592 1.1457 6.86797 1.29252 6.65905C1.98319 7.39725 3.41684 7.8685 4.99998 7.8685C6.58313 7.8685 8.01678 7.39725 8.70745 6.65905ZM8.68386 4.31816C8.84632 4.53693 8.92855 4.76587 8.92855 5.00004C8.92855 6.09049 7.16622 6.97756 4.99998 6.97756C2.83374 6.97756 1.07141 6.09049 1.07141 5.00004C1.07141 4.76587 1.15365 4.53693 1.31611 4.31816C2.0153 5.04111 3.44058 5.50287 4.99998 5.50287C6.55938 5.50287 7.98466 5.04111 8.68386 4.31816ZM4.99998 0.714355C7.16622 0.714355 8.92855 1.60143 8.92855 2.69182C8.92855 3.78226 7.16622 4.66934 4.99998 4.66934C2.83374 4.66934 1.07141 3.78226 1.07141 2.69182C1.07141 1.60143 2.83374 0.714355 4.99998 0.714355Z" :fill="cc.btn_text_color || gc.text_color"/>
                  </svg>
                  <span class="need-score" :style="{color: cc.btn_text_color || gc.text_color}">{{item.cost}}</span>
                </template>
                <!-- 有剩余，显示剩余描述 -->
                <template v-if="item.left_state == 1">
                  <span class="divider" :style="{'background-color': cc.btn_text_color || gc.text_color}"></span>
                  <span class="left_percent" :style="{'color': cc.btn_text_color || gc.text_color}">剩{{item.left_desc}}</span>
                </template>
                <!-- 没剩余了 -->
                <span v-else-if="item.left_state == 0" :style="{'color': cc.btn_text_color ? hexToRgba(cc.btn_text_color, .5) : hexToRgba(gc.main_color, .5)}">已抢光</span>
              </template>
              <div class="border-mask" :style="{'border': `1px solid ${cc.btn_color ? hexToRgba(cc.btn_color, item.reach_limit == 1 || item.left_state == 0 ? .5 : .7) : hexToRgba(gc.main_color, item.reach_limit == 1 || item.left_state == 0 ? .5 : .7)}`}"></div>
            </div>
          </div>
        </div>
      </div> 
    </div>
    <Modal ref="success-modal" :width="299" :gc="gc" :cc="cc" title="兑换成功">
      <div class="success-modal-wrapper modal-content">
        <div class="modal-item">
          <div class="image-box">
            <img :src="award.img_url" alt="">
          </div>
          <p class="prize-name" :style="{'color': gc.main_color}">{{award.name}}</p>
        </div>
        <p class="distribute-desc" :style="{'color':  hexToRgba(gc.main_color, .8)}">{{notify_content}}</p>
        <div class="btn-done" @click="closeSuccessModal" :style="{'background': cc.modal_confirm_btn_big || gc.modal_confirm_btn_big ? `url(${cc.modal_confirm_btn_big || gc.modal_confirm_btn_big}) no-repeat center/contain` : '#0B8AFF', 'color': gc.text_color,'margin-top': '10px'}">确认</div>
      </div>
    </Modal>
     <two-btn-modal title="是否确认兑换" :desc="award.name" :cc="cc" :gc="gc" @callback="exchange" ref="confirm-modal"/>
     <Modal ref="record-modal" title="兑换记录" :width="299" :gc="gc" :cc="cc">
      <div class="record-modal-wrapper modal-content">
        <div class="record-content">
          <no-data v-if="record_list.length === 0" :color="gc.main_color" desc="暂时没有兑换记录"/>
          <template v-else>
            <div class="record-list">
              <div class="record-item" v-for="record, index in record_list" :key="record.time + index">
                <div class="prize">
                  <p class="name" :style="{'color': gc.main_color}">{{record.name}}</p>
                </div>
                  <p class="record-score" :style="{'color': gc.main_color}">{{record.cost}}积分</p>
                <p class="desc" :style="{'color': gc.main_color}">{{record.time | formatTime}}</p>
              </div>
            </div>
            <p class="distribute-desc" :style="{'color': gc.main_color}">虚拟奖品已放入 我-黑盒商城-我的卡券</p>
          </template>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { utils } from '_lib/utils'
import { exchange, getRecordList } from '_api/activity-common-template'
import { eventBus } from '_lib/event-bus'
import { ComponentCommonMixin } from '../mixin'
import OrderMixin from '../mixins/order'

export default {
  mixins: [ComponentCommonMixin, OrderMixin],
  computed: {
    redeem_list () {
      return this.cd.redeem_list || []
    },
  },
  data () {
    return {
      award: {},
      record_list: [],
      notify_content: '',
      score_left: '-'
    }
  },
  mounted () {
    this.score_left = this.gd.score_left
    eventBus.$on("changeVal", (key, val) => {
      this[key] = val
    });
  },
  watch: {
    gd (gd) {
      this.score_left = gd.score_left
    }
  },
  methods: {
    exchange () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      if (this.award.category === 'sku_eligibility') {
        this.registerOrder(this.award)
      } else {
        exchange({
          heybox_id: this.querys.heybox_id,
          act_id: this.act_id || this.querys.act_id,
          item_id: this.award.item_id,
          task_os_type: this.querys.task_os_type,
          client_version: this.querys.version
        }).then(res => {
          this.closeConfirmModal()
          if (res.data.status == 'ok') {
            this.score_left = res.data.result.left_count
            this.notify_content = res.data.result.notify_content
            this.$parent.reload()
            eventBus.$emit("changeVal", 'score_left', this.score_left)
            this.showSuccessModal()
          } else {
            utils.showMessage('failed', res.data.msg)
          }
        }).catch(() => {
          this.closeConfirmModal()
          utils.showMessage('failed', '网络错误！')
        })
      }
    },
    getRecordList () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      this.reportData()
      getRecordList({
        heybox_id: this.querys.heybox_id,
        act_id: this.act_id || this.querys.act_id,
        task_os_type: this.querys.task_os_type,
        client_version: this.querys.version
      }).then(res => {
        if (res.data.status == 'ok') {
          this.record_list = res.data.result.exchange_log
          this.showRecordModal()
        } else {
          utils.showMessage('failed', res.data.msg)
        }
      })
    },
    callback () {
      this.exchange()
    },
    showConfirmModal (item) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      this.reportData('.' + item.item_id)
      if (item.reach_limit == 1 || item.left_state == 0) {
        return
      }
      this.award = item
      this.$refs['confirm-modal'].$refs['modal'].showModal()
    },
    closeConfirmModal () {
      this.$refs['confirm-modal'].$refs['modal'].hideModal()
    },
    showSuccessModal () {
      this.$refs['success-modal'].showModal()
    },
    closeSuccessModal () {
      this.$refs['success-modal'].hideModal()
    },
    showRecordModal () {
      this.$refs['record-modal'].showModal()
    },
    closeRecordModal () {
      this.$refs['record-modal'].hideModal()
    },
  },
  filters: {
    formatTime (timestamp) {
      if (isNaN(timestamp)) {
        return ''
      }
      var now = Math.ceil((new Date().getTime()) / 1000)
      var delta = Math.ceil((now - timestamp))

      if (delta < 60) {
        return `${delta}秒前`
      } else if (delta < 3600) {
        return `${Math.floor(delta/60)}分钟前`
      } else if (delta < 3600 * 24) {
        return `${Math.floor(delta/3600)}小时前`
      } else {
        return `${Math.floor(delta / (3600*24))}天前`
      }
    }
  }
}
</script>

<style lang="less" scoped>
.exchange-container {
  margin: 32px 14px 0;
  .score-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      .text {
        opacity: .7;
        font-size: 13px;
        line-height: 18px;
      }
      .num {
        font-weight: 500;
        font-size: 13px;
        line-height: 18px;
      }
    }
    .right {
      text-decoration: underline;
      font-size: 13px;
      line-height: 18px;
    }
  }
  .exchange-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 13px;
    flex: 1;
    &.center {
      justify-content: center;
    }
    .item {
      position: relative;
      background-color: #1C1D1E;
      width: calc((100% - 4px) / 3);
      .outer-box {
        height: 100%;
        padding: 13px 12px 16px;
        .img-box {
          position: relative;
          width: 62px;
          height: 62px;
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .inner-box {
          flex: 1;
          width: 100%;
          .desc {
            margin: 8px auto;
            min-height: 32px;
            font-size: 12px;
            line-height: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            .limit {
              font-weight: 500;
              font-size: 10px;
              line-height: 14px;
              color: #FFF;
              padding: 0 3px;
              text-align: center;
            }
          }
          .exchange-btn {
            width: 100%;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 22px;
            text-align: center;
            font: 10px/22px PingFang SC;
            border-radius: 4px;
            .divider {
              width: .5px;
              height: 8px;
              margin: 0 3px;
            }
            .left_percent {
              font-size: 10px;
              line-height: 14px;
              color: #FFF;
            }
            .need-score {
              font-weight: 500;
              font-size: 12px;
              line-height: 18px;
              font-family: Oswald;
              margin: 0 2px;
            }
          }
        }
      }
    } 
    .exchanged {
      .outer-box {
        .img-box,.desc {
          opacity: .5;
        }
        .inner-box {
          .exchange-btn {
            .border-mask {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: calc(200% - 2px);
              height: calc(200% - 2px);
              transform-origin: 0 0;
              transform: scale(0.5, 0.5);
              border: 1px solid #55565A;
              border-radius: 4px;
              pointer-events: none;
            }
          }
        }
      }
    }
  }
  .success-modal-wrapper {
    .modal-item {
      .image-box {
        width: 74px;
        height: 74px;
        position: relative;
        overflow: hidden;
        margin: 14px auto;
        border-radius: 2px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .prize-name {
        font-size: 13px;
        line-height: 16px;
        max-width: 100%;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .confirm-modal-wrapper {
    .modal-item {
      margin: 14px auto;
      .prize-name {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        opacity: .6;
        text-align: center;
      }
    }
    .btn-wrapper {
      display: flex;
      justify-content: center;
      .btn {
        width: calc(100% - 9px); 
        text-align: center;
        line-height: 36px;
        font-weight: 500;
        font-size: 15px;
        letter-spacing: .25px;
      }
      .btn-cancel {
        margin-right: 9px;
      }
    }
  }
  .record-modal-wrapper {
    width: 100%;
    border-radius: 10px;
    position: relative;
    .record-content{
      position: relative;
      z-index: 2;
      .record-list{
        width: 100%;
        margin: 16px 0 20px;
        max-height: 36.75vh;
        overflow-y: scroll;
        overflow-x: hidden;
        width: 100%;
        .record-item{
          width: 90%;
          height: 24px;
          margin: 10px auto 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          &:first-of-type{
            margin-top: 0;
          }
          .desc{
            flex: 1;
            line-height: 16px;
            font-size: 12px;
            text-align: right;
          }
          .record-score {
            flex: 1;
            height: 16px;
            line-height: 16px;
            font-size: 12px;
          }
          .prize{
            flex: 1;
            width: 0;
            height: 16px;
            display: flex;
            margin-right: 14px;
            .name{
              line-height: 17px;
              font-size: 12px;
              font-weight: 500;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              opacity: .7;
            }
          }
        }
      }
      .distribute-desc{
        line-height: 15px;
        font-size: 11px;
        margin-top: 11px;
        text-align: center;
        opacity: .8;
      }
    }
  }
}
</style>